import VMasker from "vanilla-masker";

function cellphoneMask(value:any){
    let maskedValue = value
    let unmaskedValue = maskedValue.replace(/\D/g, "")
    unmaskedValue = unmaskedValue.substring(0, 11)
    maskedValue = VMasker.toPattern(unmaskedValue, "(99) 99999-9999")
    return maskedValue
}

function cpfMask(value:any){
    let maskedValue = value;
    let unmaskedValue = maskedValue.replace(/\D/g, "")
    unmaskedValue = unmaskedValue.substring(0, 11)
    maskedValue = VMasker.toPattern(unmaskedValue, "999.999.999-99")
    return maskedValue
}

function numberMask(value:any){
    return VMasker.toNumber(value);
}   

export default {
    cellphoneMask,
    cpfMask,
    numberMask
}